import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/api";
import { TrackCard, TrackRow } from "@/components/TrackViews";
import { ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function Discover() {
  const [tracks, setTracks] = useState([]);
  const [sort, setSort] = useState("trending");

  useEffect(() => {
    axios.get(`${API}/tracks?sort=${sort}&limit=24`).then(r => setTracks(r.data));
  }, [sort]);

  const hero = tracks[0];
  const grid = tracks.slice(1, 9);
  const list = tracks.slice(9);

  return (
    <div className="player-space">
      {/* Marquee */}
      <div className="border-y border-neutral-900 overflow-hidden">
        <div className="whitespace-nowrap py-2 font-mono-ui text-[11px] uppercase tracking-[0.3em] text-neutral-500 animate-[tick_30s_linear_infinite]"
             style={{ animation: "tick 40s linear infinite" }}>
          New releases this week — Signal to Noise Vol. 03 out now — Stella Creative Music Showcase — Submit your demos — Artists keep 100% ownership — Payouts weekly —
          New releases this week — Signal to Noise Vol. 03 out now — Stella Creative Music Showcase —
        </div>
      </div>

      {/* Editorial Hero */}
      {hero && (
        <section className="grid grid-cols-1 lg:grid-cols-12 gap-8 px-4 md:px-10 py-12 border-b border-neutral-900">
          <div className="lg:col-span-7 relative aspect-[4/3] overflow-hidden border border-neutral-900">
            <img src={hero.cover_url || "https://images.unsplash.com/photo-1778694277012-4ce263a91c70?w=1200"}
                 alt={hero.title} className="w-full h-full object-cover cover-hover" />
            <div className="absolute left-6 top-6 font-mono-ui text-[11px] uppercase tracking-[0.3em] text-neutral-300 bg-black/60 px-2 py-1">
              Featured / {hero.genre || "Issue 01"}
            </div>
          </div>
          <div className="lg:col-span-5 flex flex-col justify-between">
            <div>
              <div className="font-mono-ui text-[11px] uppercase tracking-[0.3em] text-red-500">Now Playing on Stella Creative Music</div>
              <h1 className="font-display text-5xl sm:text-7xl font-black tracking-tighter uppercase leading-[0.9] mt-4" data-testid="hero-title">
                {hero.title}
              </h1>
              <div className="font-mono-ui uppercase tracking-widest text-sm text-neutral-400 mt-4">{hero.artist_name}</div>
              <p className="font-editorial text-2xl text-stone-300 mt-8 leading-snug">
                "A platform where the music comes first — distribution, streaming, and a career playbook, built for the artists making it next."
              </p>
            </div>
            <div className="mt-8 flex gap-3">
              <Link to="/upload" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 font-mono-ui text-xs uppercase tracking-[0.25em] transition-colors" data-testid="cta-release">
                Release a Track <ArrowRight size={14} />
              </Link>
              <Link to="/coach" className="inline-flex items-center gap-2 border border-neutral-700 hover:border-white px-6 py-3 font-mono-ui text-xs uppercase tracking-[0.25em] transition-colors" data-testid="cta-coach">
                AI Career Coach
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Sort tabs */}
      <section className="px-4 md:px-10 py-8">
        <div className="flex items-end justify-between mb-8 border-b border-neutral-900 pb-4">
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">The Feed</h2>
          <div className="flex gap-5">
            {[["trending", "Trending"], ["new", "New"], ["liked", "Most Liked"]].map(([k, l]) => (
              <button key={k}
                      onClick={() => setSort(k)}
                      className={`font-mono-ui text-[11px] uppercase tracking-[0.25em] pb-1 border-b-2 transition-colors ${sort === k ? "border-red-600 text-white" : "border-transparent text-neutral-500 hover:text-white"}`}
                      data-testid={`sort-${k}`}>
                {l}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10">
          {grid.map((t) => <TrackCard key={t.id} track={t} list={tracks} />)}
        </div>

        {list.length > 0 && (
          <div className="mt-14 border border-neutral-900">
            <div className="px-4 py-3 border-b border-neutral-900 font-mono-ui text-[11px] uppercase tracking-[0.3em] text-neutral-400">
              More from the catalog
            </div>
            {list.map((t, i) => <TrackRow key={t.id} track={t} index={i} list={tracks} />)}
          </div>
        )}
      </section>
    </div>
  );
}
